export const ED_CONTEXT_MENU_EVENTS = {
  SHOW_CONTEXT_MENU: 'SHOW_CONTEXT_MENU',
  CLOSE_CONTEXT_MENU: 'CLOSE_CONTEXT_MENU',
  UPDATE_OPTIONS_CONTEXT_MENU: 'UPDATE_OPTIONS_CONTEXT_MENU'
}

export const ED_CONTEXT_MENU_TYPES = {
  ITEMS: 'EdContextMenuItems',
  BLANK: 'EdContextMenuBlank',
  NAV: 'EdContextMenuNav'
}

export const ED_CONTEXT_MENU_DIRECTIONS = {
  BOTTOM_TO_TOP: {
    code: 'BOTTOM_TO_TOP',
    cssClass: 'ed-context-menu--bottom-to-top'
  },
  TOP_TO_BOTTOM: {
    code: 'TOP_TO_BOTTOM',
    cssClass: 'ed-context-menu--top-to-bottom'
  },
  RIGH_TO_LEFT: {
    code: 'RIGH_TO_LEFT',
    cssClass: 'ed-context-menu--right-to-left'
  },
  LEFT_TO_RIGHT: {
    code: 'LEFT_TO_RIGHT',
    cssClass: 'ed-context-menu--left-to-right'
  }
}